export let BASESTORAGE;

export default (initialData) => {
	BASESTORAGE = initialData['BASESTORAGEVARIABLE'];

	return BASESTORAGE;
};
